import Vue from "vue"
import Router from "vue-router"
import store from "@/store";
import routeConst from "./constant";
import { filterRoutes } from "@/utils";
import Layout from "@/views/layout/baseLayout.vue";
import { teacherRolePermission } from "@/config/permission";

// 保存原来的push函数
const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;
// 重写push函数
Router.prototype.push = function push(location) {
	// 这个if语句在跳转相同路径的时候，在路径末尾添加新参数（一些随机数字）
	if (typeof (location) == "string") {
		var Separator = "&";
		if (location.indexOf('?') == -1) { Separator = '?'; }
		location = location + Separator + "random=" + Math.random().toString(36).substr(2);
	} else if (location.query) {
		location.query.random = Math.random().toString(36).substr(2)
	} else if (!location.query) {
		location.query = { random: Math.random().toString(36).substr(2) }
	}

	// 这个语句用来解决报错
	// 调用原来的push函数，并捕获异常
	return originalPush.call(this, location).catch(error => error);
};

// 重写replace函数
Router.prototype.replace = function replace(location) {
	// 这个if语句在跳转相同路径的时候，在路径末尾添加新参数（一些随机数字）
	if (typeof (location) == "string") {
		var Separator = "&";
		if (location.indexOf('?') == -1) { Separator = '?'; }
		location = location + Separator + "random=" + Math.random().toString(36).substr(2);
	} else if (location.query) {
		location.query.random = Math.random().toString(36).substr(2)
	} else if (!location.query) {
		location.query = { random: Math.random().toString(36).substr(2) }
	}
	// 这个语句用来解决报错
	// 调用原来的replace函数，并捕获异常
	return originalReplace.call(this, location).catch(error => error);
};
Vue.use(Router);

const router = new Router({
	mode: "history",
	scrollBehavior: () => ({ y: 0 }),
	routes: routeConst.constRoutes
});

let asyncRoutes = [];
const generateRoutes = (next, to) => {
	if (!store.getters.teacherInfo || !store.getters.teacherInfo.id) {
		setTimeout(() => {
			generateRoutes(next, to);
		}, 200)
		return
	}

	if (store.getters.isManager) {
		asyncRoutes = routeConst.asyncRoutes;
	} else if (store.getters.hasTeacherRole) {
		asyncRoutes = filterRoutes(teacherRolePermission, routeConst.asyncRoutes)
	} else {
		asyncRoutes = filterRoutes([], routeConst.asyncRoutes)
	}

	router.addRoutes([
		{
			path: "/",
			name: "layout",
			component: Layout,
			redirect: { name: asyncRoutes[0].name },
			isRedirect: true,
			children: asyncRoutes
		},
		...routeConst.errorRoutes
	])
	router.options.routes = [...router.options.routes, {
		path: "/",
		name: "layout",
		component: Layout,
		redirect: { name: asyncRoutes[0].name },
		isRedirect: true,
		children: asyncRoutes
	},
	...routeConst.errorRoutes]
	next({ ...to, replace: true })

}

router.beforeEach((to, from, next) => {
	let accessToken = localStorage.getItem("accessToken");
	document.querySelector("#tbamc-loading").style.display = "none";
	if (routeConst.whiteList.includes(to.name)) {
		next();
	} else if (!accessToken) {
		next("/login");
	} else if (router.options.routes.length === 3) {
		generateRoutes(next, to);
	} else if (accessToken) {
		next();
	} else {
		next("/login");
	}
});


export default router;
